export default function Gallery() {
  const galleryImages = [
    {
      image: '/images/fiat 500 abarth/IMG_2723.jpeg',
      title: 'Fiat 500 Abarth',
      parts: 'Front Splitter · Side Skirts · Rear Diffuser',
    },
    {
      image: '/images/aventador/DAA25BE1-F4C1-4E76-8E06-6B621980904A.jpg',
      title: 'Lamborghini Aventador',
      parts: 'Full Aero Kit · Side Blades · Rear Wing',
    },
    {
      image: '/images/porsche/IMG_9626.JPG',
      title: 'Porsche',
      parts: 'GT Wing · Diffuser · Side Blades',
    },
    {
      image: '/images/g klasa/IMG_5174.JPG',
      title: 'Mercedes G-Klasa',
      parts: 'Front Splitter · Mirror Caps · Side Steps',
    },
    {
      image: '/images/megan 4/IMG_1604.JPG',
      title: 'Renault Mégane 4',
      parts: 'Front Splitter · Side Skirts · Rear Spoiler',
    },
    {
      image: '/images/megan 3/IMG_1639.JPG',
      title: 'Renault Mégane 3',
      parts: 'Front Lip · Side Skirts · Rear Diffuser',
    },
    {
      image: '/images/fiat 500 abarth/IMG_2925.jpeg',
      title: 'Fiat 500 Abarth',
      parts: 'Hood Carbon · Mirror Caps · Rear Spoiler',
    },
    {
      image: '/images/g klasa/IMG_6642.JPG',
      title: 'Mercedes G-Klasa',
      parts: 'Full Exterior Package · Mirror Caps',
    }
  ];

  return (
    <section id="gallery" className="bg-gray-50 py-16 md:py-32 relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
        {/* Section Header */}
        <div className="mb-10 md:mb-16">
          <div className="flex items-center gap-3 mb-4 md:mb-6">
            <div className="w-8 md:w-12 h-[2px] bg-black"></div>
            <span className="text-gray-500 text-xs uppercase tracking-[3px] font-bold">CUSTOMER BUILDS</span>
          </div>
          <h2 className="text-black text-4xl sm:text-5xl md:text-6xl font-black tracking-tight leading-[1.1] mb-4 md:mb-6">
            GALLERY
          </h2>
          <p className="text-gray-600 text-base md:text-xl max-w-3xl">
            Real builds from our community. Track weapons, street legends, and show stoppers—all featuring our precision carbon fiber components.
          </p>
        </div>

        {/* Desktop Masonry Grid */}
        <div className="hidden md:grid grid-cols-12 gap-6 mb-12">
          {/* Row 1 */}
          <div className="col-span-4 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[600px] overflow-hidden">
              <img src={galleryImages[0].image} alt={galleryImages[0].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[0].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[0].parts}</p>
              </div>
            </div>
          </div>
          <div className="col-span-8 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[600px] overflow-hidden">
              <img src={galleryImages[1].image} alt={galleryImages[1].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[1].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[1].parts}</p>
              </div>
            </div>
          </div>
          {/* Row 2 */}
          <div className="col-span-5 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[500px] overflow-hidden">
              <img src={galleryImages[2].image} alt={galleryImages[2].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[2].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[2].parts}</p>
              </div>
            </div>
          </div>
          <div className="col-span-4 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[500px] overflow-hidden">
              <img src={galleryImages[3].image} alt={galleryImages[3].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Detail</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[3].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[3].parts}</p>
              </div>
            </div>
          </div>
          <div className="col-span-3 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[500px] overflow-hidden">
              <img src={galleryImages[4].image} alt={galleryImages[4].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[4].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[4].parts}</p>
              </div>
            </div>
          </div>
          {/* Row 3 */}
          <div className="col-span-7 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[400px] overflow-hidden">
              <img src={galleryImages[5].image} alt={galleryImages[5].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[5].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[5].parts}</p>
              </div>
            </div>
          </div>
          <div className="col-span-5 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[400px] overflow-hidden">
              <img src={galleryImages[6].image} alt={galleryImages[6].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[6].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[6].parts}</p>
              </div>
            </div>
          </div>
          {/* Row 4 */}
          <div className="col-span-5 group relative overflow-hidden cursor-pointer bg-white">
            <div className="relative h-[400px] overflow-hidden">
              <img src={galleryImages[7].image} alt={galleryImages[7].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-2 mb-3"><div className="w-8 h-[2px] bg-white"></div><span className="text-white/70 text-xs uppercase tracking-[2px] font-bold">Build</span></div>
                <h3 className="text-white text-2xl font-black mb-2">{galleryImages[7].title}</h3>
                <p className="text-white/80 text-sm">{galleryImages[7].parts}</p>
              </div>
            </div>
          </div>
          {/* Submit CTA Card */}
          <div className="col-span-7 relative overflow-hidden cursor-pointer bg-black border-4 border-black hover:border-gray-300 transition-all group">
            <div className="relative h-[400px] flex flex-col items-center justify-center p-12 text-center">
              <div className="w-20 h-20 flex items-center justify-center mb-6 bg-white rounded-full group-hover:scale-110 transition-transform">
                <i className="ri-camera-line text-4xl text-black"></i>
              </div>
              <h3 className="text-white text-4xl font-black mb-4 uppercase tracking-tight">Submit Your Build</h3>
              <p className="text-gray-400 text-lg mb-8 max-w-md">Share your EagleCarbon build with our community and get featured in our gallery</p>
              <button className="bg-white px-10 py-4 text-black font-bold text-base hover:bg-gray-200 transition-all whitespace-nowrap group/btn">
                <span className="flex items-center gap-3">UPLOAD PHOTOS<i className="ri-arrow-right-line text-xl group-hover/btn:translate-x-1 transition-transform"></i></span>
              </button>
              <div className="absolute top-8 left-8 w-16 h-16 border-t-2 border-l-2 border-white/30"></div>
              <div className="absolute bottom-8 right-8 w-16 h-16 border-b-2 border-r-2 border-white/30"></div>
            </div>
          </div>
        </div>

        {/* Mobile Grid - clean 1 col / 2 col layout */}
        <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          {galleryImages.map((item, index) => (
            <div key={index} className="group relative overflow-hidden cursor-pointer bg-white">
              <div className="relative h-[240px] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-base font-black mb-1">{item.title}</h3>
                  <p className="text-white/70 text-xs">{item.parts}</p>
                </div>
              </div>
            </div>
          ))}
          {/* Mobile Submit CTA */}
          <div className="sm:col-span-2 relative overflow-hidden cursor-pointer bg-black group">
            <div className="relative h-[200px] flex flex-col items-center justify-center p-8 text-center">
              <div className="w-14 h-14 flex items-center justify-center mb-4 bg-white rounded-full group-hover:scale-110 transition-transform">
                <i className="ri-camera-line text-2xl text-black"></i>
              </div>
              <h3 className="text-white text-2xl font-black mb-3 uppercase tracking-tight">Submit Your Build</h3>
              <button className="bg-white px-8 py-3 text-black font-bold text-sm hover:bg-gray-200 transition-all whitespace-nowrap">
                UPLOAD PHOTOS
              </button>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <button className="group relative bg-black px-8 md:px-12 py-4 md:py-6 text-white font-bold text-base md:text-lg hover:bg-gray-900 transition-all overflow-hidden whitespace-nowrap cursor-pointer border-2 border-black hover:border-gray-700 w-full sm:w-auto">
            <span className="relative z-10 flex items-center justify-center gap-3">
              VIEW ALL BUILDS
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
